<template>
  <div class="bg-gray-light">
    <section>
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="bt-return" @click="gotoList()">
              {{ $t("translation.Retour") }}
            </div>
            <!-- <div
              :class="{
                'carousel-heart': true,
                active: $store.state.favories.indexOf(offer.of_id) >= 0
              }"
              @click="addFavorite()"
            >
              <icon
                :name="
                  $store.state.favories.indexOf(offer.of_id) >= 0
                    ? 'heart'
                    : 'regular/heart'
                "
                scale="2"
              />
            </div> -->
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col pr-0 pl-0">
            <immo-carousel-offer
              v-if="offerImages.length"
              :images="offerImages"
              :canEnlarge="true"
              :of_id="slugOffer"
              imageSize="medium"
            />
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container">
        <div class="row">
          <div class="col text-center">
            <div class="mt-3 mb-2">
              <span
                class="detail-ligne1"
                v-html="
                  $options.filters.formatOfferName(
                    offer,
                    false,
                    false,
                    $t.bind(this),
                    $tc.bind(this)
                  )
                "
              ></span>
            </div>
            <div class="container-name d-flex flex-row justify-content-center">
              <h1 class="detail-title">
                {{ offer["of_name_" + $i18n.locale.toLowerCase()] }}
              </h1>
              <!-- <div class="add-favory pointer" @click="addFavory">
                <img
                  :src="
                    favory ? '/images/coeur-rouge.png' : '/images/coeur.png'
                  "
                  alt=""
                />
              </div> -->
            </div>
            <!-- <h2
              v-html="$options.filters.formatOfferPrices(offer, ' | ', false)"
            ></h2> -->
            <h2 class="offer-price color-red">
              <span v-if="offer.of_rent">{{ offer.of_price_rent }}</span>
              <span v-if="offer.of_rent && offer.of_sell"> / </span>
              <span v-if="offer.of_sell">{{ offer.of_price_sell }}</span>
            </h2>

            <table style="width:100%;" class="d-md-none">
              <tr>
                <td>
                  <img
                    src="/images/icones-services/icons8-canape-100.png"
                    alt=""
                  />
                </td>
                <td>
                  <img
                    src="/images/icones-services/icons8-lit-100.png"
                    alt=""
                  />
                </td>
                <td>
                  <img
                    src="/images/icones-services/icons8-baignoire-100.png"
                    alt=""
                  />
                </td>
              </tr>
              <tr>
                <td>
                  {{ offer.of_nbpieces > 0 ? offer.of_nbpieces : "" }}
                  {{ $tc("translation.piece", offer.of_nbpieces) }}
                </td>
                <td>
                  {{ offer.of_nbrooms > 0 ? offer.of_nbrooms : "" }}
                  {{ $tc("translation.chambre", offer.of_nbrooms) }}
                </td>
                <td>
                  {{ offer.of_nbbathrooms > 0 ? offer.of_nbbathrooms : "" }}
                  {{ $tc("translation.sdb", offer.of_nbbathrooms) }}
                </td>
              </tr>
            </table>

            <div class=" mt-3 mb-2  justify-content-center d-none d-md-flex">
              <div class="d-flex" v-if="offer.of_nbpieces > 0">
                <div class="mr-1">
                  <img
                    src="/images/icones-services/icons8-canape-100.png"
                    alt=""
                  />
                </div>
                <div class="mr-4">
                  {{ offer.of_nbpieces }}
                  {{ $tc("translation.piece", offer.of_nbpieces) }}
                </div>
              </div>
              <div class="d-flex" v-if="offer.of_nbrooms > 0">
                <div class="mr-1">
                  <img
                    src="/images/icones-services/icons8-lit-100.png"
                    alt=""
                  />
                </div>
                <div class="mr-4">
                  {{ offer.of_nbrooms }}
                  {{ $tc("translation.chambre", offer.of_nbrooms) }}
                </div>
              </div>
              <div class="d-flex" v-if="offer.of_nbbathrooms > 0">
                <div class="mr-1">
                  <img
                    src="/images/icones-services/icons8-baignoire-100.png"
                    alt=""
                  />
                </div>
                <div>
                  {{ offer.of_nbbathrooms }}
                  {{ $tc("translation.sdb", offer.of_nbbathrooms) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12 d-flex flex-row justify-content-center">
            <button
              @click="printOffer"
              class="btn btn-secondary2 d-flex flex-row align-items-center mr-2"
            >
              <!--  <icon name="print" class="mr-2"></icon> -->
              <img
                class="mr-2"
                src="/images/printer-simple-line-icons.png"
                alt=""
              />
              {{ $t("translation.Imprimer") }}
            </button>

            <div
              class="btn btn-secondary d-flex flex-row align-items-center  mr-2 ml-2"
              style="cursor:default;"
            >
              <div
                class="mr-1 share share-insta  d-flex flex-row align-items-center justify-content-center"
              >
                <a
                  href="https://www.instagram.com/pvnrealestate/"
                  target="_blank"
                >
                  <img src="/images/social-insta.png" alt=""
                /></a>
              </div>
              <div
                class="mr-1 share share-facebook  d-flex flex-row align-items-center justify-content-center"
              >
                <a
                  href="https://www.facebook.com/pvnrealestate/"
                  target="_blank"
                >
                  <img
                    src="/images/social-facebook-simple-line-icons.png"
                    alt=""
                /></a>
              </div>
              <!--  <div class="share share-insta mr-2"></div>
              <div class="share share-facebook mr-2"></div> -->
              {{ $t("translation.Partager") }}
            </div>

            <button
              v-if="offer.of_video"
              @click="videoOffer"
              class="btn btn-secondary3 d-flex flex-row align-items-center mr-2"
            >
              <!--  <icon name="print" class="mr-2"></icon> -->
              <img class="mr-2" src="/images/social-insta.png" alt="" />
              Video
            </button>
          </div>
        </div>
        <div class="row mt-5 mb-4">
          <div class="col-md-3">
            <h4>{{ $t("translation.Resume") }}</h4>
            <table style="width:100%;">
              <tr v-if="offer.of_surface">
                <td>{{ $t("translation.Surface_totale") }} :</td>
                <td class="text-right color-red">
                  {{ offer.of_surface }}m<sup>2</sup>
                </td>
              </tr>
              <tr v-else-if="offer.of_surface_livable">
                <td>{{ $t("translation.Surface_habitable") }} :</td>
                <td class="text-right color-red">
                  {{ offer.of_surface_livable }}m<sup>2</sup>
                </td>
              </tr>
              <tr v-if="offer.of_surface_terrace">
                <td>{{ $t("translation.Surface terrace") }} :</td>
                <td class="text-right color-red">
                  {{ offer.of_surface_terrace }}m<sup>2</sup>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-md-7 offset-md-2">
            <h4 class="mt-3 mt-md-0">
              {{ $t("translation.Description_de_loffre") }} {{ offer.of_ref }}
            </h4>
            <p
              class="color-gray"
              v-html="
                $options.filters.nl2br(
                  offer['of_text_' + $i18n.locale.toLowerCase()]
                )
              "
            ></p>
            <div
              class="color-gray"
              v-if="
                offer.bu_id &&
                  offer.bu_id['bu_description_' + $i18n.locale.toLowerCase()]
              "
            >
              <h6>{{ $t("translation.Limmeuble") }} :</h6>
              <p
                v-html="
                  $options.filters.nl2br(
                    offer.bu_id['bu_description_' + $i18n.locale.toLowerCase()]
                  )
                "
              ></p>
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </section>
    <hr />

    <section class="section-services" v-if="items_of_services_filtered.length">
      <div class="container">
        <div class="row">
          <div class="col">
            <h4>{{ $t("translation.Les_services") }}</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <!-- <hr style="margin-bottom:8px;" /> -->
            <div class="row container-service">
              <div
                class="col-md-4 p-0"
                v-for="service in items_of_services_filtered"
                :key="'of_service_' + service.value"
              >
                <hr />
                <div
                  class="service d-flex flex-row align-items-center selected"
                >
                  <div class="container-icon mr-3">
                    <img
                      class=""
                      :src="'/images/icones-services/' + service.icon"
                      alt=""
                    />
                  </div>
                  <p class="color-gray">
                    {{ service["label_" + $i18n.locale.toLowerCase()] }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <hr />

    <section class="py-5">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h4>{{ $t("translation.Je_souhaite_visiter_ce_bien") }}</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-5">
            <div class="card">
              <div class="card-body">
                <div class="row d-flex flex-row align-items-center">
                  <!-- <div class="col-md-5">
                    <img class="img-fluid" src="/images/pieter.jpg" alt="" />
                  </div> -->
                  <div class="col-md-12">
                    <!-- <h5 class="card-title">Card title</h5> -->
                    <div class="card-text">
                      <div class="bis uppercase">Pieter van Naeltwijck</div>
                      <div class="color-gray-light uppercase small-text">
                        real estate investments
                        <!-- {{ $t("translation.Agent_commercial") }} -->
                      </div>
                      <div class="mt-3">
                        {{ $t("translation.Tel") }} :
                        <a class="color-black" href="tel:+37797707020"
                          >+377 97 70 70 20</a
                        >
                        <br />
                        {{ $t("translation.Email") }} :
                        <a
                          class="color-black"
                          href="mailto:pvnrealestate@monaco.mc"
                          >pvnrealestate@monaco.mc</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <form>
              <div class="form-group">
                <input
                  v-model="newContact.name"
                  :placeholder="$t('translation.Nom_et_prenom')"
                  type="text"
                  class="form-control color-gray-light"
                  id="contact_name"
                />
              </div>
              <div class="form-group">
                <input
                  v-model="newContact.email"
                  :placeholder="$t('translation.Email')"
                  type="email"
                  class="form-control"
                  id="contact_email"
                />
              </div>
              <div class="form-group">
                <input
                  v-model="newContact.tel"
                  :placeholder="$t('translation.Tel')"
                  type="text"
                  class="form-control"
                  id="contact_telephone"
                />
              </div>
              <button
                @click="contactme"
                type="button"
                class="btn btn-primary d-flex flex-row align-items-center"
              >
                <icon name="phone-alt" class="mr-2"></icon>
                <span>{{ $t("translation.Contactez_moi") }}</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <div
      class="modal fade"
      id="videoModal"
      tabindex="-1"
      aria-labelledby="videoModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <!-- <h5 class="modal-title" id="videoModalLabel">Video</h5> -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="videook">
            <div
              v-html="offer.of_video"
              class="d-flex justify-content-center"
            ></div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div>
    <header-title></header-title>
    <section>
      <div class="container mt-4">
        <div class="row my-5">
          <div class="col-md-8">
            <h2>{{ offer.of_name_fr }}</h2>
          </div>
          <div
            class="col-md-4 d-flex justify-content-center justify-content-md-end"
          >
            <button
              @click="changeOffer('prev')"
              class="btn btn-primary py-1 btn-prev-next-offer"
              :disabled="prevOffer === ''"
            >
              Précédent
            </button>
            <button
              @click="changeOffer('next')"
              :disabled="nextOffer === ''"
              class="btn btn-primary py-1 ml-3 btn-prev-next-offer"
            >
              Suivant
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <immo-carousel-offer
              v-if="offerImages.length"
              :images="offerImages"
              :canEnlarge="true"
              :of_id="slugOffer"
              imageSize="medium"
            />
            <div class="mt-2">
              <immo-offer-distances :row_of="offer"></immo-offer-distances>
            </div>
            <h5 class="mt-3">Description du bien</h5>
            <h6>L'appartement :</h6>
            <div class="d-flex flex-row flex-wrap color-gray">
              <span v-if="offer.of_surface" class="mx-2">
                Surface totale : {{ offer.of_surface }} m2</span
              >
              <span v-if="offer.of_surface_livable" class="mx-2">
                Surface de la chambre : {{ offer.of_surface_livable }} m2</span
              >
            </div>
            <div class="d-flex flex-row flex-wrap color-gray">
              <span v-if="offer.of_nbpieces" class="mx-2">
                Nombre de pièces : {{ offer.of_nbpieces }}
              </span>
              <span v-if="offer.of_nbrooms" class="mx-2">
                Nombre de chambre : {{ offer.of_nbrooms }}
              </span>
            </div>
            <div class="d-flex flex-row flex-wrap color-gray mb-2">
              <span v-if="offer.of_etage" class="mx-2">
                Étage n° {{ offer.of_etage }}
              </span>
            </div>
            <p v-html="$options.filters.nl2br(offer.of_text_fr)"></p>
            <div v-if="offer.bu_id && offer.bu_id.bu_description_fr">
              <h6>L'immeuble :</h6>
              <p
                v-html="$options.filters.nl2br(offer.bu_id.bu_description_fr)"
              ></p>
            </div>
            <h5 class="mt-5 mb-2">Les services associés</h5>
            <div class="row">
              <h6 class="col-md-12 mb-3">
                Services associés à l'appartement :
              </h6>
              <div
                v-for="service in items_of_services"
                :key="'of_service_' + service.value"
                class="service col-6 col-sm-4 col-md-3 col-lg-2 d-flex flex-column align-items-center"
                :class="
                  offer.of_services & service.value
                    ? 'selected'
                    : 'not-selected'
                "
              >
                <img :src="'/images/icones-services/' + service.icon" alt="" />
                <p>{{ service.label }}</p>
              </div>
              <h6 class="col-md-12 my-3">
                Services associés à l'immeuble :
              </h6>

              <div
                v-for="service in items_bu_services"
                :key="'bu_service_' + service.value"
                class="service col-6 col-sm-4 col-md-3 col-lg-2 d-flex flex-column align-items-center"
                :class="
                  offer.bu_id && offer.bu_id.bu_services & service.value
                    ? 'selected'
                    : 'not-selected'
                "
              >
                <div v-if="offer.bu_id">
                  <img
                    :src="'/images/icones-services/' + service.icon"
                    alt=""
                  />
                  <p>{{ service.label }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class=" aside">
              <div class="offer-type d-flex flex-row">
                <div
                  class="offer-type-detail"
                  :class="offer.of_type === 1 ? 'appart' : 'family'"
                >
                  {{
                    offer.of_type === 1 ? "Appartement" : "Famille d'accueil"
                  }}
                </div>
                <div class="uppercase ml-2">{{ offer | formatPieces }}</div>
              </div>
              <div class="surface mt-4">{{ offer.of_surface }} m2</div>
              <div class="bis price ">{{ offer.of_rent_sum }}€</div>
              <div>
                {{ offer.disponibility === 1 ? "Disponibilité immédiate" : "" }}
              </div>
              <h5 class="mt-4">Déposer ma candidature</h5>
              <account-form
                v-if="!$store.state.connected"
                v-model="row_co"
              ></account-form>
              <div class="row">
                <div class="col-md-6">
                  <m-form-date
                    :name="$Utils.randomstring('datestart')"
                    v-model="dateStart"
                    placeholder="Date d'entrée"
                  ></m-form-date>
                </div>
                <div class="col-md-6">
                  <m-form-date
                    :name="$Utils.randomstring('dateend')"
                    v-model="dateEnd"
                    placeholder="Date de sortie"
                  ></m-form-date>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-12 d-flex flex-row justify-content-center">
                  <vue-recaptcha
                    ref="invisibleRecaptcha"
                    @verify="onVerify"
                    @expired="onExpired"
                    :sitekey="google_key"
                    :loadRecaptchaScript="true"
                    theme="light"
                  ></vue-recaptcha>
                </div>
              </div>
              <button
                class="btn btn-primary w-100"
                @click="ask"
                v-if="notAlreadyCandidate"
              >
                Déposer ma candidature
              </button>
              <button
                class="btn btn-secondary  w-100"
                @click="ask"
                disabled
                v-else
              >
                Candidature déjà déposée
              </button>
            </div>
          </div>
        </div>
        <div class="row mt-2 mb-5">
          <div class="col-md-12 d-flex justify-content-end">
            <router-link class="logo" to="/">
              <button class="btn btn-primary py-1">Retour</button></router-link
            >
          </div>
        </div>
      </div>
    </section>
    <m-message-dialog
      v-model="messageDialog"
      :title="messageDialogTitle"
      :text="messageDialogTxt"
    ></m-message-dialog>
  </div> -->
</template>

<script>
//import VueRecaptcha from "vue-recaptcha";
export default {
  name: "immoofferdetails",
  //components: { VueRecaptcha },
  props: {},
  data() {
    let dateStart = "",
      dateEnd = "";
    if (this.$store.state.request_datestart)
      dateStart = this.$store.state.request_datestart;
    if (this.$store.state.request_datestop)
      dateEnd = this.$store.state.request_datestop;
    return {
      newContact: {
        name: "",
        firstname: "",
        country: "",
        email: "",
        tel: "",
        message: ""
      },
      videook: false,
      offer: {},
      slugOffer: "",
      offerImages: [],
      items_of_services: [],
      // items_of_services_filtered: [],
      // items_bu_services: [],
      nextOffer: "",
      prevOffer: "",
      // candidature //
      // row_co: {
      //   co_civility: "0",
      //   co_firstname: "",
      //   co_name: "",
      //   co_email1: "",
      //   co_password: "",
      //   co_tel1: "",
      //   co_country: "0"
      // },
      google_key: this.$config.google_key,
      row_co: null,
      dateStart,
      dateEnd,
      messageDialog: false,
      messageDialogTxt: "",
      messageDialogTitle: "",
      recaptcha: false,
      favory: false
    };
  },
  computed: {
    notAlreadyCandidate() {
      let me = this;
      let f = this.$_.find(this.$store.state.myactions, function(o) {
        return o.of_id.of_id == me.offer.of_id;
      });
      return !f;
    },
    items_of_services_filtered() {
      return this.items_of_services.filter(item => {
        if (window.BigInt)
          return (
            window.BigInt(this.offer.of_services) & window.BigInt(item.value)
          );
        return this.offer.of_services & item.value;
      });
    }
  },
  watch: {
    $route(to, from) {
      this.loadOffer();
    }
  },
  async mounted() {
    // this.row_co = this.$store.state.user;
    // console.log("immoOffer.mounted : this.row_co", this.row_co);
    this.loadOffer();
    this.$$("#videoModal").on("hidden.bs.modal", () => {
      this.videook = false;
    });
  },
  methods: {
    async contactme() {
      this.newContact.message =
        "Contactez moi pour " +
        this.offer.of_ref +
        " | " +
        this.offer.of_name_fr;
      let response = await this.$axios.post(
        this.$config.server_url + "/web/1.0/contactus",
        this.newContact
      );
      // console.log("response", response);
      if (response.data.err) {
        this.messageDialog = true;
        this.messageDialogTxt = this.$t(
          "Une erreur est survenue, votre message n'a pas pu être envoyé"
        );
        this.messageDialogTitle = this.$t("Erreur");
      }
      if (response.data.data && response.data.data.success) {
        this.messageDialog = true;
        this.messageDialogTxt = this.$t("Votre message a bien été envoyé");
        this.messageDialogTitle = this.$t("Confirmation");
        this.resetNewContact();
      }
    },
    videoOffer() {
      this.videook = true;
      this.$$("#videoModal").modal("show");
    },
    gotoList() {
      this.$router.push("/offers");
    },
    addFavorite() {
      this.$store.dispatch("addFavorite", this.offer.of_id);
      // this.favory = !this.favory;
      // if (this.favory) {
      //   //on l'ajoute
      //   // console.log(
      //   //   "this.$store.state.favories, this.offer.of_id",
      //   //   this.$store.state,
      //   //   this.offer.of_id
      //   // );
      //   this.$store.state.favories.push(this.offer.of_id);
      // } else {
      //   //on l'enlève
      //   let index;
      //   for (let i = 0; i < this.$store.state.favories.length; i++) {
      //     const fav = this.$store.state.favories[i];
      //     if (fav === this.offer.of_id) index = i;
      //   }
      //   this.$store.state.favories.splice(index, 1);
      // }
      // this.$store.commit("set_favories", {
      //   offers: this.$store.state.favories
      // });
    },
    // inputRowCo(row_co) {
    //   this.row_co = row_co;
    //   console.log("this.row_co", this.row_co);
    // },
    printOffer() {
      window.open(
        this.$config.server_url +
          "/api/1.0/offers/" +
          this.offer.of_id +
          "/print?type=complete&lang=" +
          this.$i18n.locale.toLowerCase() +
          "&d=" +
          new Date().getTime(),
        "_blank"
      );
    },
    async loadOffer() {
      this.prevOffer = "";
      this.nextOffer = "";
      this.offerImages = [];
      return new Promise((accept, reject) => {
        this.$nextTick(async () => {
          this.slugOffer = this.$route.params.slug;
          let params = { lang: this.$store.state.lang };
          let response = await this.$axios.get(
            this.$config.server_url + "/web/1.0/offers/" + this.slugOffer,
            { params }
          );
          // console.log('response', response);
          if (!response || !response.data) return accept();

          if (response.data.data.images) {
            this.offerImages = response.data.data.images;
          }
          this.offer = response.data.data;
          if (this.offer.of_video) {
            // this.offer.of_video.
          }
          this.items_of_services = response.data.items_services;
          // console.log("items_of_services", this.items_of_services);
          // this.items_bu_services = response.data.items_bu_services;
          let offersFavories = this.$store.state.favories;
          for (let iof = 0; iof < offersFavories.length; iof++) {
            if (offersFavories[iof] === this.offer.of_id) {
              this.favory = true;
            }
          }
          accept();
        });
      });
    },
    changeOffer(sens) {
      let route;
      if (sens === "prev") {
        route = "/immo/offer/" + this.prevOffer;
      } else {
        route = "/immo/offer/" + this.nextOffer;
      }
      this.$router.push(route);
    },
    async ask() {
      if (this.$store.state.connected) return this.goAsk();
      let row_co;
      if (!this.row_co) row_co = this.$store.state.user;
      else row_co = this.row_co;
      let requiredField = [
        { text: "Civilité", value: row_co.co_civility },
        { text: "Prénom", value: row_co.co_firstname },
        { text: "Nom", value: row_co.co_name },
        { text: "Email", value: row_co.co_email1 },
        { text: "Téléphone", value: row_co.co_tel1 },
        { text: "Pays", value: row_co.co_country },
        { text: "Date d'entrée", value: this.dateStart },
        { text: "Date de sortie", value: this.dateEnd },
        { text: "Test robot", value: this.recaptcha }
      ];
      // return console.log("this.row_co", this.row_co.co_firstname);
      let err = [];
      for (let ifield = 0; ifield < requiredField.length; ifield++) {
        const field = requiredField[ifield];
        if (!field.value) err.push(field);
      }
      if (err.length) {
        //alert("vous devez remplir tous les champs");
        this.messageDialog = true;
        this.messageDialogTxt = "Vous devez remplir les champs : <br/>";
        this.messageDialogTitle = "Erreur";
        for (let ierr = 0; ierr < err.length; ierr++) {
          const erreur = err[ierr];
          this.messageDialogTxt += erreur.text + "<br/>";
        }
        return;
      }
      if (this.$moment(this.dateStart).isAfter(this.dateEnd)) return;

      // création du contact
      let response1 = await this.$axios.post(
        this.$config.server_url + "/web/1.0/contacts",
        row_co
      );
      if (response1.data.err) {
        // si le contact existe déjà
        this.$root
          .findFirstComponent("nav-public")
          .myaccount(
            "Votre email existe déjà dans notre base de données. Merci de vous connecter avant de continuer"
          );
        return;
      } else {
        // si le compte n'existait pas
        let response2 = await this.$axios.post(
          this.$config.server_url + "/web/1.0/signin",
          {
            co_login: row_co.co_email1,
            co_password: row_co.co_password
          }
        );
        // console.log("immoOffer.signin - response.data : ", response2.data);
        if (response2.data.data.co_id) {
          this.$store.commit("set_connexion", {
            accesstoken: response2.data.accesstoken,
            user: response2.data.data
            // offers: response2.data.data.rows_ac
          });
          this.messageDialog = true;
          this.messageDialogTxt = "Votre compte a bien été créé";
          this.messageDialogTitle = "Confirmation";
          this.goAsk();
        }
      }
    },
    async goAsk() {
      if (!this.dateStart || !this.dateEnd || !this.recaptcha) {
        this.dialogErr = true;
        this.dialogErrTxt = "Vous devez remplir les champs : <br/>";
        if (!this.dateStart) this.dialogErrTxt += "Date d'entrée <br/>";
        if (!this.dateEnd) this.dialogErrTxt += "Date de sortie <br/>";
        if (!this.recaptcha) this.dialogErrTxt += "Test robot <br/>";
        return;
      }
      this.$store.commit("set_requestdates", {
        datestart: this.dateStart,
        datestop: this.dateEnd
      });
      // demande de candidature
      let data = {
        date_start: this.dateStart,
        date_end: this.dateEnd,
        offer: this.$route.params.slug
      };

      // let response3 =
      await this.$axios.post(this.$config.server_url + "/web/1.0/ask", data, {
        headers: {
          "x-auth-webaccesstoken": this.$store.state.user.co_accesstoken
        }
      });
      await this.$store.dispatch("updateMyActions");
      // console.log("goAsk response3", response3.data);
    },
    onVerify: function(response) {
      this.recaptcha = true;
      // console.log("Verify: " + response);
    },
    onExpired: function() {
      //console.log("Expired");
      this.recaptcha = false;
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    }
  }
};
</script>
<style scoped lang="scss">
@import "../scss/styles.scss";
h4 {
  font-family: $font-nunito;
  font-size: 1.5rem;
  margin-bottom: 20px;
}
.offer-price {
  font-family: $font-nunito;
  font-size: 1.9rem;
}
.detail-ligne1 {
  font-family: $font-nunito;
  font-size: 1.2rem;
}
.detail-title {
  font-family: $font-nunito;
  // font-weight: bold;
  font-size: 3rem;
}
.btn {
  padding: 10px 10px;
  border-radius: 4px;
}
.btn-secondary:hover {
  background-color: #1d4971;
  border-color: #1d4971;
}
.share {
  height: 30px;
  width: 30px;
}

.share-insta:hover {
  background-color: #cf4078;
  border-radius: 50%;
}
.share-facebook:hover {
  background-color: #6e8eb8;
  border-radius: 50%;
}
.card,
.form-control {
  border-radius: 0;
}
h1 {
  font-size: 60px;
}
.section-services {
  padding: 40px 0 20px 0;
}
// .container-name {
// }
.add-favory img {
  margin-left: 15px;
  width: 26px;
  margin-top: 10px;
}
h6 {
  font-size: 18px;
}
h2 {
  color: #d71e29;
}
.service {
  text-align: center;
  p {
    margin: 0;
  }
  hr {
    margin: 0 !important;
  }
  .container-icon {
    width: 45px;
    height: 30px;
    padding-left: 15px;
  }
  img {
    max-width: 25px;
    max-height: 25px;
  }
}
.container-service {
  // padding: 0px 30px !important;
  padding: 0 15px;
  hr {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
  }
}
// .selected {
//   // background-color: green;
// }
.not-selected {
  opacity: 0.2;
}
.aside {
  background-color: #f4f4f4;
  border-radius: 10px;
  padding: 25px 20px;
  //max-height: 1000px;
}
.btn-prev-next-offer {
  border-radius: 8px;
  max-height: 40px;
}
.offer-type-detail {
  padding: 2px 7px;
  border-radius: 5px;
  color: #fff;
}
.family {
  background-color: #ffc400;
}
.appart {
  background-color: #03b1ff;
}
.price {
  font-size: 30px;
}
.surface {
  font-size: 20px;
}
// .btn.btn-primary,
// .btn.btn-secondary {
//   padding: 20px;
// }
.btn-secondary:disabled {
  color: #fff;
  background-color: #92989c;
  border-color: #92989c;
}
.bt-return {
  position: absolute;
  z-index: 2;
  border-radius: 3px;
  padding: 5px 15px;
  cursor: pointer;
  top: 10px;
  background-color: rgba(255, 255, 255, 0.6);
}
/* .carousel-heart {
  position: absolute;
  color: white;
  z-index: 1000;
  top: 20px;
  right: 20px;
  cursor: pointer;
  &.active {
    color: #d71e29;
  }
} */
.btn-secondary3 {
  background-color: salmon;
}
.modal-header {
  background-color: white;
}
</style>
